import script from "./colors.vue?vue&type=script&lang=js"
export * from "./colors.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__